import axios from 'axios'
import { config } from '../Config/config'

const DetailDoctorService ={
    
    getID : (id) => {
        const result = axios.get(config.apiUrl + '/Doctor_getbyID/'+ id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    getESP : (id) => {
        const result = axios.get(config.apiUrl + '/Doctor_esp/'+ id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    getSP : () => {
        const result = axios.get(config.apiUrl + '/Doctor_sp')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    getBiodata : (bio) => {
        const result = axios.post(config.apiUrl + '/Doctor_biodata', bio)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    getProfile : (bio) => {
        const result = axios.post(config.apiUrl + '/Doctor_profile', bio)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },

    getSP : () => {
        const result = axios.get(config.apiUrl + '/Doctor_sp')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },

    getTreatment : (treat) => {
        const result = axios.post(config.apiUrl + '/Doctor_treatment', treat)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },

    getEducation : (edu) => {
        const result = axios.post(config.apiUrl + '/Doctor_education', edu)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },
    addSP : (data) => {
        const result = axios.post(config.apiUrl + '/Doctor_addSP', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },

    editSP : (data) => {
        const result = axios.put(config.apiUrl + '/Doctor_editSP', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },

    getHistory : (hist) => {
        const result = axios.post(config.apiUrl + '/Doctor_historyPraktek', hist)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },

    getLokasi : (loc) => {
        const result = axios.post(config.apiUrl + '/Doctor_lokasi', loc)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },

    getJadwal : (schedule) => {
        const result = axios.post(config.apiUrl + '/Doctor_jadwal', schedule)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    },

    getValidJadwal : (schedule) => {
        const result = axios.post(config.apiUrl + '/Doctor_validasi_jadwal', schedule)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error => {
            return {
                success :false,
                error : error
            }
        })
        return result
    }
}

export default DetailDoctorService